import React, { useEffect } from 'react';
import { ReactP5Wrapper } from "react-p5-wrapper";

let color = '#000000'
let strokeWeight = 3;
let p5 = undefined;
let undoStack = [];
const MAX_UNDO = 5;

function sketch(p) {
    window.myP5 = p;
    let canvas; // Declare canvas at the top of the sketch function
    p5 = p;

    p.setup = function () {
        canvas = p.createCanvas(700, 500); // Assign the p5 canvas to the variable
        p.pixelDensity(1);
        p.noFill();
        p.background(255);
    };

    // Expose a method to draw externally
    p.externalDraw = (x, y, px, py) => {
        //console.log('externalDraw');
        if (!p) return;
        p.stroke(color);
        p.strokeWeight(strokeWeight);
        p.line(x, y, px, py);
    };

    p.saveState = () => {
        if (undoStack.length >= MAX_UNDO) {
            undoStack.shift();
        }
        let img = p.get();
        undoStack.push(img);
    };

    p.undo = () => {
        if (undoStack.length > 0) {
            let previousState = undoStack.pop();
            p.clear();
            p.background(255); // Ensure background is reset if needed
            p.image(previousState, 0, 0);
        } else {
            console.log('No more actions to undo.');
        }
    };

}

function floodFill(p, seed, fillColorHex) {
    console.log('Density: ' + p.pixelDensity());
    let fillColor = hexToRGB(fillColorHex, 255);
    console.log('seed' + seed.x + ' ' + seed.y);   
    console.log(fillColor);
    p.loadPixels();

    let index = 4 * (p.width * seed.y + seed.x);
    let seedColor = [
        p.pixels[index],
        p.pixels[index + 1],
        p.pixels[index + 2],
        p.pixels[index + 3],
    ];

    let queue = [];
    queue.push(seed);
    let loopCount = 0;
    
    while (queue.length) {
        let current = queue.shift();
        index = 4* (p.width * current.y + current.x);
        let color = [
            p.pixels[index],
            p.pixels[index + 1],
            p.pixels[index + 2],
            p.pixels[index + 3],
        ];

        if (!arrayEquals(color, seedColor)) {
            continue;
        }

        p.pixels[index] = fillColor[0];
        p.pixels[index + 1] = fillColor[1];
        p.pixels[index + 2] = fillColor[2];
        p.pixels[index + 3] = fillColor[3];
        

        loopCount++;
        if (loopCount > 50000) break;

        expandToNeighbours(p, queue, current)
    }

    p.updatePixels()
}

function expandToNeighbours(p, queue, current) {

    let x = current.x;
    let y = current.y;

    if (x - 1 > 0) {
        queue.push({x: x - 1, y: y});
    }

    if (x + 1 < p.width) {
        queue.push({x: x + 1, y: y});
    }

    if (y - 1 > 0) {
        queue.push({x: x, y: y - 1});
    }

    if (y + 1 < p.height) {
        queue.push({x: x, y: y + 1})
    }

    return queue;
}

function arrayEquals(a, b) {
    return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index])
    );
}

function fill(x, y, color) {
    console.log('filling', x, y, color);
    floodFill(p5, {x: x, y: y }, color);
}

function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    return [r, g, b, alpha];
}

function ViewingCanvas({ socket }) {

    useEffect(() => {
        // Handle socket event to draw from external data
        socket.on('drawing', mouseCords => {
            const { x, y, px, py } = mouseCords;
            if (window.myP5) {
                window.myP5.externalDraw(x, y, px, py);
            }
        });

        socket.on('sc', data => {
            color = data.color;
        });

        socket.on('setweight', data => {
            strokeWeight = data.weight;
        });

        socket.on('fill', data => {
            fill(data.x, data.y, data.color);
        });
        
        socket.on('clear', data => {
            clearCanvas();
        });

        socket.on('undo', () => {
        });

        socket.on('snap', () => {
        });
    
        function clearCanvas() {
            if (p5) {
                p5.background(255);
            }
        }

        return () => {
            socket.removeAllListeners('drawing');
            socket.off('fill');
            socket.removeAllListeners('sc');
            socket.off('clear');
        };
    }, [socket]);

    return <ReactP5Wrapper sketch={(p) => sketch(p, socket)} />;
}

export default ViewingCanvas;